import React from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateBadgeInfo } from '../actions'

const IncompleteBadgeImage = props => {
  const handleChange = newImage => {
    let newName = newImage.name
    let badgeInfo = {}
    let reader = new FileReader()
    reader.readAsDataURL(newImage)
    reader.onload = e => {
      badgeInfo.incompleteImage = e.target.result
      badgeInfo.incompleteImageName = newName
      badgeInfo.incompleteImageLoaded = true
      badgeInfo.incompleteNewUploadedImage = true
      props.updateInfo(badgeInfo)
    }
  }
  return (
    <div className="image_info">
      <input
        type="file"
        id="image_input"
        accept=".png, .jpeg, .jpg"
        onChange={e => handleChange(e.target.files[0])}
      />
      <p>{props.incompleteImageName ? props.incompleteImageName : ''}</p>
    </div>
  )
}

IncompleteBadgeImage.propTypes = {
  header: PropTypes.string,
  incompleteImageName: PropTypes.string,
  image: PropTypes.object,
  updateInfo: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    incompleteImageName: state.badgeInfo.incompleteImageName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateInfo: badgeInfo => {
      dispatch(updateBadgeInfo(badgeInfo))
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IncompleteBadgeImage)
)
